import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import ReactDOMServer from 'react-dom/server';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {Map} from "immutable";
import {Icon, ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import QuoteDetail from "./QuoteDetail";
import QuoteFiles from './QuoteFiles';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';
import QuotePrint from "../../../components/common/QuotePrint";

// Actions
import {
    getQuote,
    updateQuote,
    changeQuoteStatus,
    uploadQuoteFiles,
    downloadQuoteFile,
    deleteQuoteFile,
    deleteQuote,
    cleanQuotes
} from "../../../actions/quotes";
import {addNotification} from "../../../actions/notifications";
import {downloadPdf} from "../../../actions/content";

class QuoteTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getQuote(this.props.match.params.quoteId);
    }
    componentWillUnmount() {
        this.props.cleanQuotes();
    }

    // Tab handlers
    getSelectedIndex() {
        const {quoteId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/ventas/presupuestos/' + quoteId + '/detalle':
                return 0;
            case '/ventas/presupuestos/' + quoteId + '/ficheros':
                return 1;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {quoteId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/ventas/presupuestos/' + quoteId + '/detalle';
                break;
            case 1:
                route = '/ventas/presupuestos/' + quoteId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // QuoteDetail handlers
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.updateQuoteState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateQuote();
        this.setState({
            editMode: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Print PDF
    printPdf = (type) => {
        const htmlHeader = ReactDOMServer.renderToStaticMarkup(<div></div>);
        const generateStaticMarkup = ReactDOMServer.renderToStaticMarkup(
            <QuotePrint
                quote={this.props.quote}
                type={type}
            />
        );
        const htmlFooter = ReactDOMServer.renderToStaticMarkup(
            <div style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <div style={{ alignSelf: 'flex-end', fontSize: 12, marginRight: '30px' }}>
                    - <span className="pageNumber"></span> -
                </div>
                <div style={{ fontSize: 6 }} >INSCRITA EN EL REGISTRO MERCANTIL DE MURCIA, TOMO MU-3142, FOLIO 112, HOJA MU-87833</div>
            </div>
        );

        this.props.downloadPdf(generateStaticMarkup, {
            title: this.props.quote.get('quote_code') + '.pdf',
            printBackground: true,
            displayHeaderFooter: true,
            headerTemplate: htmlHeader,
            footerTemplate: htmlFooter,
            margin: {
                top: '50px',
                right: '50px',
                left: '50px',
                bottom: '150px'
            }
        });
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, editMode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar presupuesto',
                        body: (
                            <DeleteDialog
                                text={ this.props.quote.get('quote_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteQuote(this.props.quote.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/ventas/presupuestos');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/presupuestos">Presupuestos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ this.props.quote.get('quote_code') }</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {!editMode
                                    ? <div className="title-action">
                                        <button
                                            className="btn btn-custom"
                                            onClick={ () => this.printPdf('proforma') }
                                        ><Icon icon="print"/>Factura Proforma</button>
                                        <button
                                            className="btn btn-custom"
                                            onClick={ () => this.printPdf('quote') }
                                        ><Icon icon="print"/>Imprimir</button>
                                        { this.props.quote.get('status') === 'accepted'
                                            ? <button
                                                className="btn btn-primary"
                                                onClick={ () => {
                                                    this.props.history.push('/ventas/pedidos/nuevo', {
                                                        quote: this.props.quote
                                                    });
                                                }}
                                            >
                                                <Icon icon="insert"/>Pedido
                                            </button>
                                            : null
                                        }
                                        { this.props.quote.get('can_delete')
                                                ? <button
                                                    className="btn btn-danger"
                                                    onClick={ () => this.openModal('deleteDialog') }
                                                >Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                { this.props.quote.get('_id')
                                    ? (
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <QuoteDetail
                                                onRef={ref => (this.child = ref)}
                                                editMode={this.state.editMode}
                                                canSubmit={this.canSubmit}
                                                quote={this.props.quote}
                                                updateQuote={this.props.updateQuote}
                                                changeQuoteStatus={this.props.changeQuoteStatus}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <QuoteFiles
                                                quote={this.props.quote}
                                                uploadQuoteFiles={this.props.uploadQuoteFiles}
                                                uploadProgress={this.props.uploadProgress}
                                                downloadQuoteFile={this.props.downloadQuoteFile}
                                                deleteQuoteFile={this.props.deleteQuoteFile}
                                                addNotification={this.props.addNotification}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                                        )
                                        : null
                                    }
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const quoteReducer = state.quotes;

    // Quote
    let quote = quoteReducer.get('payload') || Map({});

    if (!(quote instanceof Map)) {
        quote = Map({})
    }

    // Upload Progress
    const uploadProgress = Map({
        isUploading: quoteReducer.get('isUploading') || false,
        percent: quoteReducer.get('percent') || 0
    });

    return {
        quote,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getQuote: (quoteId) => dispatch(getQuote(quoteId)),
        updateQuote: (quoteId, quote) => dispatch(updateQuote(quoteId, quote)),
        changeQuoteStatus: (quoteId, status) => dispatch(changeQuoteStatus(quoteId, status)),
        uploadQuoteFiles: (quoteId, files) => dispatch(uploadQuoteFiles(quoteId, files)),
        downloadQuoteFile: (quoteId, fileId) => dispatch(downloadQuoteFile(quoteId, fileId)),
        deleteQuoteFile: (quoteId, fileId) => dispatch(deleteQuoteFile(quoteId, fileId)),
        deleteQuote: (quoteId) => dispatch(deleteQuote(quoteId)),
        cleanQuotes: () => dispatch(cleanQuotes()),
        addNotification: (notification) => dispatch(addNotification(notification)),
        downloadPdf: (htmlString, pdfOptions) => dispatch(downloadPdf(htmlString, pdfOptions))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteTabs);



// WEBPACK FOOTER //
// ./src/containers/sales/quotes/QuoteTabs.js